import { Component, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
    selector: 'card-support',
    templateUrl: './card-support.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardSupportComponent extends CardComponent {}
